import {Client, DEVICES, TRACKER} from "../../service/Client";
import {CLEAR, error, loading} from "../users/usersActionsCreator";
import {getPositionsCreator, getStatusCreator} from "./trackerActionsCreator";

let client = new Client();

export function getStatus(projectId) {
	return dispatch => {
		client.get(`${TRACKER}/project/${projectId}`)
			.then(resp => {
				resp.data.forEach(d => {
					d.timestamp = dateToItalianLocale(d.timestamp);
					d.lastPositionTimestamp = dateToItalianLocale(d.lastPositionTimestamp);
					dispatch(getPositions(d.deviceId));
				});
				dispatch(getStatusCreator(resp.data));
			})
			.catch( e => manageError(e,dispatch))
	}
}

export function getPositions(device, params) {
	return dispatch => {
		client.get(`${TRACKER}/${device}/data`, {params})
			.then(resp => {
				//resp.data.forEach(p => p.timestamp = dateToItalianLocale(p.timestamp));
				//resp.data.forEach(p => p.lastPositionTimestamp = dateToItalianLocale(p.lastPositionTimestamp));
				dispatch(getPositionsCreator(device, resp.data))
			})
			.catch( e => manageError(e,dispatch))
	}
}

export function changeLabel(projectId, deviceId, label) {
	return dispatch => client
		.post(`${DEVICES}/${deviceId}/label`, {body:label, headers:{"Content-Type":"text/plain"}})
		.then(() => dispatch(getStatus(projectId)))
		.catch(e => manageError(e,dispatch));
}

function manageError(e, dispatch) {
	dispatch(loading(false));
	if (e.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		dispatch(error(e.response.data.message));
	} else {
		// Something happened in setting up the request that triggered an Error
		console.log('Error', e.message);
		dispatch(error(e.message));
	}
}

export function clear() {
	return {
		type: CLEAR
	};
}

function dateToItalianLocale(date) {
	return new Date(date).toLocaleString('it-IT')
}
function stringToItalianLocale(date) {
	return new Date(Date.parse(`${date}Z`)).toLocaleString('it-IT')
}
